import { render, staticRenderFns } from "./r-search-kind.vue?vue&type=template&id=4f1be232"
import script from "./r-search-kind.vue?vue&type=script&lang=js"
export * from "./r-search-kind.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f1be232')) {
      api.createRecord('4f1be232', component.options)
    } else {
      api.reload('4f1be232', component.options)
    }
    module.hot.accept("./r-search-kind.vue?vue&type=template&id=4f1be232", function () {
      api.rerender('4f1be232', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/search/r-search-kind.vue"
export default component.exports